import { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { useLoad } from "@/lib/api";

export default function PatientPicker({ value, onChange, testid = "patient-picker" }) {
  const { data: patients } = useLoad("/patients", []);
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    return s ? patients.filter((p) => `${p.name} ${p.opd} ${p.phone}`.toLowerCase().includes(s)) : patients;
  }, [patients, q]);
  return (
    <label>Patient
      <div className="picker">
        <div className="picker-search"><Search size={14} /><input data-testid={`${testid}-search`} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filter by name, OPD or phone" /></div>
        <select data-testid={testid} required value={value} onChange={(e) => onChange(e.target.value)}>
          <option value="">Select a patient…</option>
          {list.map((p) => <option key={p.id} value={p.id}>{p.name} · {p.opd}{p.phone ? ` · ${p.phone}` : ""}</option>)}
        </select>
      </div>
    </label>
  );
}
